import { AssistantPart } from '@services/modules/AssistantStream'

import { KW } from './ui'

/*
 * What the server remarks about an answer once it is whole: that it stopped at the length
 * limit, or that it names a record number the looked-up data does not carry. The text is the
 * server's own (never the model's) and is shown as plain text under the answer, above its
 * sources. A notice the client does not know by its code is shown the same way; a part of
 * another type is not a notice and renders nothing here.
 */

export const NOTICE_PART = 'notice'

/** The answer stopped at the model's output limit. */
export const NOTICE_ANSWER_CUT_SHORT = 'ANSWER_CUT_SHORT'

const noticesOf = (parts?: AssistantPart[]) =>
  (parts ?? []).filter(
    part => part.type === NOTICE_PART && !!part.label?.trim()
  )

export const hasNotice = (parts: AssistantPart[] | undefined, code: string) =>
  noticesOf(parts).some(part => part.code === code)

const AnswerNotices = ({ parts }: { parts?: AssistantPart[] }) => {
  const notices = noticesOf(parts)
  if (notices.length === 0) {
    return null
  }

  return (
    <div className="mt-2 flex flex-col gap-1">
      {notices.map((notice, index) => (
        <div
          key={`${notice.code ?? NOTICE_PART}-${index}`}
          role="note"
          data-notice={notice.code}
          className="rounded-md px-[10px] py-[6px] text-xs leading-[1.45]"
          style={{
            background: KW.amberBg,
            color: KW.amber,
            border: `1px solid ${KW.line2}`,
          }}
        >
          {notice.label}
        </div>
      ))}
    </div>
  )
}

export default AnswerNotices
